import {Network} from '@capacitor/network';
import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';

const initialState = {
  isOnline: true
};

export const NetworkStatusStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    init(): void {
      Network.getStatus().then((status) => {
        patchState(store, { isOnline: status.connected });
      });

      Network.addListener('networkStatusChange', status => {
        patchState(store, { isOnline: status.connected });
      });
    },
    setOffline(): void {
      patchState(store, { isOnline: false });
    },
    setOnline(): void {
      patchState(store, { isOnline: true });
    }
  })
));
